export const CONNECTION_INFO = {
  host: process.env.NODE_ENV !== 'production' ? 'https://cxmde.im-fine.dev' : window.location.origin 
}
